module.exports = __webpack_public_path__ + "img/Frame626182.26ef8aaf.png";